import { Dialog } from 'primereact/dialog'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingIndicator from '../../LoadingIndicator'
import { resolveMissingHawb } from '../../../services/csnDashboardService'
import getPrincipal from '../../../utils/getPrincipal'
import getPLACIUser from '../../../utils/getPLACIUser'
import warningIcon from '../../../assets/images/warning_filled.svg'
import { PrimaryButton, SecondaryButton } from '../../../common/Buttons'
import './resolve-missing-hawb-popup.scss'



const ResolveMissingHawbPopup = ({
    resolveMissingHawbPopup,
    setResolveMissingHawbPopup ,
    flightData,
    setShowLoader,
    setAlertMessage,
    setStatus,
}) => {
    const { t } = useTranslation(['labels'])
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        console.log('flightData', flightData);
    }, [flightData])


    const handleNo = () => {
        setResolveMissingHawbPopup({
            isOpen: false,
            awbNumber: null
        })
    }

    const handleYes = async () => {

        try {
            setShowLoader(true)
            const principal = getPrincipal()
            const placiUser = getPLACIUser()

            const reqObj = {
                userId:  principal?.sub,
                userStation: placiUser?.stationCode ? placiUser?.stationCode : null,
                awbNumber: resolveMissingHawbPopup.awbNumber,
                flightId: flightData.flightId,
                userType: principal?.type,

            }
            console.log('reqObj', reqObj);
            const response = await resolveMissingHawb(reqObj)
            console.log('response', response);
            if (response && response.status === 200) {
                setAlertMessage(`Missing HAWB discrepancy successfully resolved for AWB ${resolveMissingHawbPopup.awbNumber}.`)
                setStatus(true)
            } else {
                setAlertMessage(`Missing HAWB discrepancy could not be resolved for AWB ${resolveMissingHawbPopup.awbNumber}, please retry. If problem persists, please contact IT support.`)
                setStatus(false)
            }
        } catch (error) {
            console.log(error)
            setAlertMessage(`Missing HAWB discrepancy could not be resolved for AWB${resolveMissingHawbPopup.awbNumber}, please retry. If problem persists, please contact IT support.`)
            setStatus(false)
        } finally {
            setShowLoader(false)
            setResolveMissingHawbPopup({
                isOpen: false,
                awbNumber: null
            })
            window.scrollTo(0, 0)
        }

    }

    const RenderFooter = () => {
        return (
            <div className='footer'>
                <SecondaryButton label={t('COMMON.YES')} onClick={handleYes} />
                <PrimaryButton label={t('COMMON.NO')} onClick={handleNo} />
            </div>
        )
    }

    return (
        <div className='cargo-portal-container dialog-container resolve-missing-hawb-dialog'>
            <div className='portal-dialog p-fluid'>
                <Dialog
                    footer={<RenderFooter />}
                    visible
                    modal
                    closable={true}
                    header=''
                    onHide={handleNo}
                >
                    <div className='warning-icon-container'>
                        <img src={warningIcon} alt='Warning' />
                    </div>
                

                    <div className='mt-1 mb-4 dialog-header'>Resolve missing HAWB?</div>
                    <div className='inner-container'>
                        <p className='mt-2 mb-4 dialog-message'>
                            Do you want to resolve the 'Missing HAWB' discrepancy for the AWB- {resolveMissingHawbPopup.awbNumber}?
                        </p>
                        <p className='dialog-note'>
                            <strong>Note:</strong> This action is irreversible
                        </p>

                    </div>
                    
                </Dialog>
            </div>
            {isLoading && <LoadingIndicator />}
        </div>
    )
}

export default ResolveMissingHawbPopup
